import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { checkIsDocumentReStampPossible, checkIsReStampPossible, resetContractOption } from '../api/sealStamp';
import SysConfigStore from '../store/common/SysConfigStore';
import { useAlert } from './useAlert';

export function useCheckReStampPossible(contractId: string, documentId: string | null) {
	const { isComponentEnabled } = SysConfigStore();
	const { t } = useTranslation();
	const [snackbar] = useAlert();
	const [isReStampPossible, setIsReStampPossible] = useState<boolean | null>(null);

	useEffect(() => {
		if (!contractId) return;

		// isComponentEnabled 조건을 안 걸어주면, documentId를 아직 documentId를 넘겨받지 못한 것인지, 아니면 원래 documentId가 필요 없는 것인지 구분이 되지 않는다.
		if (isComponentEnabled('CMPNT419_MULTI_DOCUMENT_AND_ATTACHMENT_SIGN_BF') && !documentId) return;

		// documentId가 있다면 (419번 컴포넌트 활성화 상태) -> 문서 단위로 재날인 여부를 체크
		if (documentId) {
			checkIsDocumentReStampPossible(contractId, isComponentEnabled, documentId)
				.then(res => setIsReStampPossible(res?.data ?? false))
				.catch(() => setIsReStampPossible(false));
		} else {
			// documentId가 null인 경우 (419번 컴포넌트 비활성화 상태) -> 계약 단위로 재날인 여부를 체크
			checkIsReStampPossible(contractId, isComponentEnabled)
				.then(res => setIsReStampPossible(res?.data ?? false))
				.catch(() => setIsReStampPossible(false));
		}
	}, [contractId, documentId, isComponentEnabled]);

	useEffect(() => {
		if (!contractId) return;

		resetContractOption(String(contractId), isComponentEnabled, documentId).catch(err => {
			snackbar('옵션 초기화 중 에러 발생', 'error');
		});
	}, [isReStampPossible, contractId, isComponentEnabled]);

	return isReStampPossible;
}
